import View from '../View'

export default class TabsController extends View {
    constructor({
        tabs = new Map(),
    }) {
        super()
        this.state = {
            selectedTabKey: null,
        }
        this.tabs = tabs;
        this.onStatePropertyChanged('selectedTabKey', this._switchTab)
    }

    afterRender() {
        for (let tab of this.tabs.values()) {
            tab.hide()
        }
    }

    _switchTab = (selectedTabKey, prevTabKey) => {
        if (prevTabKey) this.tabs.get(prevTabKey).hide()
        if (selectedTabKey) this.tabs.get(selectedTabKey).show()
    }
}



// WEBPACK FOOTER //
// ./web/js/panels/TabsController.js